import { useTranslation } from "react-i18next";
import { LoaderCircle } from "lucide-react";

// Shown while the session loads so the sign-in card never flashes for
// signed-in users. index.html renders the same markup before the app boots.
export function Splash() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-label={t("auth.checkingSession")}
      className="fixed inset-0 grid place-items-center bg-background"
    >
      <LoaderCircle className="size-6 animate-spin text-muted-foreground motion-reduce:animate-none" />
    </div>
  );
}
